import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import ProductForm from '@/modules/product/components/ProductForm.vue';
import { Product } from '@/modules/product/Product';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const route = useRoute();
const product = ref<Partial<Product>>({
	type: (route.params.type as string).toUpperCase(),
	content: [],
});

const saved = (product) => {
	Flash.success($gettext('Produkt tillagd'));
	router.push({
		name: 'product.edit',
		params: { id: product.id },
	});
};

const cancel = () => {
	router.push({ name: 'product.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductForm, {
    "page-title": _unref($gettext)('Ny produkt'),
    product: product.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "product"]))
}
}

})